function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iconCopyUrl");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iconCopyUrl",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.03,13.028 L22.907,13.028 C25.6308684,13.028 27.839,10.8198684 27.839,8.096 L27.839,5.182 C27.839,2.45813161 25.6308684,0.25 22.907,0.25 L18.026,0.25",
  id: "Path_648",
  stroke: "#213368",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.063,0.25 L5.182,0.25 C2.45813161,0.25 0.25,2.45813161 0.25,5.182 L0.25,8.096 C0.249734686,9.40412905 0.769269423,10.6587567 1.69425636,11.5837436 C2.6192433,12.5087306 3.87387095,13.0282653 5.182,13.028 L10.063,13.0280001",
  id: "Path_647",
  stroke: "#213368",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5,7.75 C3.94771525,7.75 3.5,7.30228475 3.5,6.75 C3.5,6.19771525 3.94771525,5.75 4.5,5.75 L23.5140852,5.75 C24.06637,5.75 24.5140852,6.19771525 24.5140852,6.75 C24.5140852,7.30228475 24.06637,7.75 23.5140852,7.75 L4.5,7.75 Z",
  id: "Line-2",
  fill: "#D71635",
  fillRule: "nonzero"
})));

var SvgIconCopyUrl = function SvgIconCopyUrl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "16px",
    viewBox: "0 0 31 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCopyUrl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconCopyUrl.6098aaeb.svg";
export { ForwardRef as ReactComponent };